import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

export function useMergeContactAction(onDone = () => {}, onError = () => {}) {
  const queryFactory = useCallback(() => {
    const query = `mutation mergeClient($targetClientId: ID!, $sourceClientId: ID!) {
        mergeClient (targetClientId: $targetClientId, sourceClientId: $sourceClientId) {
          client {
            uuid
            name
          }
        }
      }`;

    const resolver = ({ data: { mergeClient } }) => {
      return {
        data: {
          ...mergeClient.client,
          id: mergeClient.client.uuid,
        },
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const [merge, { loading: isMerging }] = useMutationWithToaster(queryFactory, {
    onDone,
    onError,
  });

  return {
    isMerging: isMerging,
    merge: (sourceClient, targetClient) => {
      return merge(
        {
          sourceClientId: toGlobalId("Client", sourceClient.id),
          targetClientId: targetClient.id,
        },
        {
          successMsg: `Successfully merged ${sourceClient.name} into ${targetClient.name}`,
          defaultErrorMsg:
            "Failed to merge contact. Please retry or contact support for assistance.",
        }
      );
    },
  };
}

export default useMergeContactAction;
